module.exports = __webpack_public_path__ + "static/media/13-min.6c3c4a8b.png";